/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    /**
     * <h3>数据列表</h3>
     * <a href="../../ui_controls/bui.list.html" target="_blank">demo</a>
     * <p>把scroll的数据请求逻辑封装,只需要传id,url,data,模板的生成器,如果需要你的页面的逻辑比较复杂,建议参考 <a href="../../ui_controls/bui.scroll.html" target="_blank">bui.scroll</a> </p>
     * {{#crossLink "bui.list/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.list/widget"}}{{/crossLink}}: 获取依赖的scroll控件,然后使用scroll的方法 <br>
     *  @namespace bui
     *  @class list
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]  
     *  @param {string} option.url [数据请求地址]  
     *  @param {object} [option.data] [数据请求许可参数]  
     *  @param {string} [option.method] ["GET" || "POST"]  
     *  @param {number} [option.timeout] [默认:20000]  
     *  @param {object} [option.headers] [ {} ]  
     *  @param {object} [option.field] [可配置的字段]  
     *  @param {string} [option.field.page] [页数的字段名, 如果页数的字段名不是"page",需要更改]  
     *  @param {string} [option.field.size] [每页多少条的字段名, 如果条数的字段名不是"pageSize",需要更改]  
     *  @param {string} [option.field.data] [ 渲染的数据字段,有层级则使用对象字符串, 例如 'result.data.list' ]  
     *  @param {number} [option.page] [请求的数据页数, 默认:1]  
     *  @param {number} [option.pageSize] [请求每页多少条, 默认:10]  
     *  @param {string} [option.children] [列表的选择器,默认: ".bui-list"]  
     *  @param {string} [option.handle] [列表的循环子元素,默认: ".bui-btn"]  
     *  @param {number} [option.height] [列表的高度,0 自适应]  
     *  @param {boolean}  option.autoNext [ 默认true 当高度不足时,会继续请求下一页,直到高度出现滚动条 ]
     *  @param {boolean}  option.autoScroll [ 默认true 滚动到底部触发, false 自己监听 ]
     *  @param {boolean}  option.refresh [ 允许下拉刷新, 默认true | false  ]
     *  @param {function} [option.template] [ 请求到数据以后生成的模板,需要返回html字符串 ]  
     *  @param {function} [option.onRefresh] [ 刷新数据以后的回调 ]  
     *  @param {function} [option.onLoad] [ 页面渲染完成以后的回调 ]  
     *  @param {function} [option.callback] [ 点击每个handle的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="scroll" class="bui-scroll">
                <div class="bui-scroll-head"></div>
                <div class="bui-scroll-main">
                    <ul class="bui-list">
                    </ul>
                </div>
                <div class="bui-scroll-foot"></div>
            </div>
     *      
     *   js: 
     *   
            // 初始化
            var uilist = bui.list({ 
                id: "#scroll",
                url: "http://eid.bingosoft.net:82/bui/demo/json/userlist.json",
                data: {},
                height:300,
                template: template,
                callback: function() {
                    console.log($(this).text())
                }
              });

            // 生成模板
            function template (data) {
                var html = "";

                $(data).each(function(index, el) {

                    html += '<li class="bui-btn"><i class="icon-facefill"></i>'+el.name+'</li>';
                });

                return html;
            }
      
     *
     */
    ui.list = function(option){

        var config = {
            id: "",
            url: "",
            data: {},
            method: "GET",
            dataType: "json",
            headers: {},
            contentType: "",
            timeout: 20000,
            field: {
                page: "page",
                size: "pageSize",
                data: "data"
            },
            page: 1,
            pageSize: 10,
            autoNext: true,
            autoScroll: true,
            refresh : true,
            children:".bui-list",
            handle: ".bui-btn",
            height: 0,
            template: null,
            onRefresh: null,
            onLoad: null,
            onFail: null,
            callback: null
        }
        //方法
        var module = {
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true, {},config, ui.config.list, option );

        var $id,
            id,
            el,
            $children,
            $handle,
            uiAjax,
            uiScroll,
            jsonData = {},
            oldParamData = param.data,
            $target;
        
        //执行初始化
        init(param);
        
        //初始化
        function init (option) {
            option = option || param;
            
            //验证id
            $id = ui.obj( option.id );

            //option获取新参数使用
            param = module.config = option;
            jsonData = param.data ;

            var onRefresh = param.refresh == false ? null : refresh;

            //初始化滚动加载
            uiScroll = bui.scroll({
                id: option.id ,
                children: option.handle ,
                page: option.page,
                pageSize: option.pageSize,
                height: option.height,
                refresh : option.refresh,
                autoNext: option.autoNext,
                autoScroll: option.autoScroll,
                onRefresh: onRefresh,
                onLoad: load
            });

            $children = $id.find( option.children );

            $handle = $children.children( option.handle );

            //绑定事件
            bind(option);

            return this;
        }

        function bind(option) {


            //绑定搜索
            option.callback && $children.off("click.bui",option.handle).on("click.bui",option.handle,function (e) {

                option.callback.call(this,e,module,uiScroll);
                
            })

            return this;
        }

        //滚动加载下一页
        function load(start,pagesize,command) {
            //跟刷新共用一套数据
            var command = command || "append";

            jsonData = $.extend(true, {},oldParamData,param.data,jsonData );
            jsonData[param.field.page] = start,
            jsonData[param.field.size] = pagesize;

            //阻止正在请求的链接
            // if( uiAjax && uiAjax.abort ){
            //     uiAjax.abort();
            // };
            // 

            uiAjax = bui.ajax({
                url: param.url,
                data: jsonData,
                method: param.method,
                headers: param.headers,
                dataType: param.dataType,
                contentType: param.contentType,
                timeout: param.timeout
            }).done(function(res,status,xhr) {

                var dataObj,    //所有结果
                    datas;      //二级数据

                if( typeof res === "string"){
                    dataObj = res&&JSON.parse(res) || {}; 
                }else{
                    dataObj = res || {};
                }
                
                if( param.field.data == ""){
                  datas = dataObj || [];
                }else{
                  var datafields = [];
                    if( param.field.data.indexOf('.') > -1 ){
                        datafields = param.field.data.split('.');
                    }else {
                        datafields.push(param.field.data);
                    }

                  switch(datafields.length){
                      case 1 :
                          datas = typeof dataObj[datafields[0]] === "string" ? dataObj[datafields[0]] && JSON.parse(dataObj[datafields[0]]) : dataObj[datafields[0]] || [];
                      break;
                      case 2 :
                          datas = dataObj[datafields[0]][datafields[1]] ||  [];
                      break;
                      case 3 :
                          datas = dataObj[datafields[0]][datafields[1]][datafields[2]] || [];
                      break;
                  }
                }
                

                //生成html
                var html = option.template( datas, dataObj, start );

                    $children[command](html);

                //更新分页信息,如果高度不足会自动请求下一页
                uiScroll && uiScroll.updateCache(start,datas);
                
                // 刷新的时候返回位置
                param.refresh && uiScroll.reverse();

                param.onLoad && param.onLoad.call(module,uiScroll,datas,xhr);

            }).fail(function (res,status,xhr) {

                param.onFail && param.onFail(res,uiScroll,start,xhr);
                // 可以点击重新加载
                uiScroll && uiScroll.fail(start,pagesize,res);
            })

            return this;
        }

        //刷新数据
        function refresh () {

            var page = param.page;
            var pagesize = param.pageSize;

            // 要在load前面才能修改到请求的参数
            param.onRefresh && param.onRefresh.call(module,uiScroll);

            load(page,pagesize,"html");

            return this;
        };

        //动态修改参数,无需重新初始化控件
        function modifyData(key,value) {
            var obj;
            if( typeof value === "string"){
                try{
                    obj = JSON.parse(value);
                }catch(e){
                    console.log("data 参数必须为对象");
                    return;
                }
            }else{
                obj = value;
            }

            jsonData = $.extend(true,{},oldParamData,obj);

            return jsonData;
        }
        
        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 scroll ]
         *  @example 
            
            //获取依赖控件
            var uiListScroll = uiList.widget("scroll");
            
            //使用scroll的方法
            uiListScroll.nextPage();
                
         */
        function widget(name) {
            var control = { scroll: uiScroll, ajax: uiAjax };
            return ui.widget.call(control,name);
        };


        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
            var option = uiListScroll.option();

            //获取某个参数
            var id = uiListScroll.option( "id" );

            //修改一个参数
            uiListScroll.option( "height",200 );

            //修改多个参数
            uiListScroll.option( {"height":200} );
                
         */
        function options (key,value) {
            //修改data参数,不需要重新初始化
           if( key == "data" && typeof value !== "undefined"){

            return modifyData(key,value);
           }else{
            return ui.option.call(module,key,value);
           }
        }

        
        return module;
    };


    return ui;

})( bui || {}, libs );
